import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function SeatFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.61298 17.75H14.6828L12.5401 20.2499H8C7.44771 20.2499 7 20.6976 7 21.2499C7 21.8022 7.44772 22.2499 8 22.2499H18C18.5523 22.2499 19 21.8022 19 21.2499C19 20.6976 18.5523 20.2499 18 20.2499H15.1742L17.317 17.75H17.9722C19.0921 17.75 20 16.8577 20 15.7571C20 14.25 17.9722 13.7641 17.9722 13.7641C17.9722 13.7641 14.2844 12.3464 10 13.75C10 13.75 9.86099 8.62274 7.70985 2.92067C7.28543 1.79566 5.90119 1.41155 4.88539 2.0771C4.21507 2.5163 3.8807 3.30966 4.0387 4.08605L6.65836 16.1736C6.85774 17.0936 7.67165 17.75 8.61298 17.75ZM12.5 9.25C11.9477 9.25 11.5 9.69772 11.5 10.25C11.5 10.8023 11.9477 11.25 12.5 11.25H18C18.5523 11.25 19 10.8023 19 10.25C19 9.69772 18.5523 9.25 18 9.25H12.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

SeatFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default SeatFilledIcon;
